import DateFormatter from "php-date-formatter";

/**
 * Replaces the text content of <time> elements with local times.
 */
export default class Time {
	/**
	 * Constructor.
	 *
	 * @param {Object} element - A <time> element with datetime attribute.
	 */
	constructor( element ) {
		const dateTime = element.getAttribute( "datetime" );
		if ( dateTime === null || dateTime === "" ) {
			return;
		}
		element.textContent = (new DateFormatter()).formatDate(
			new Date( dateTime ),
			iPortalCore.settings.dateTimeFormat,
		);
	};
}
